import { pagetypeConstants } from "../constants";

const handlePageTypes = (list) => {
  let pageTypeHtml = list
    .filter((type) => type.parent_page_type_id != 0)
    .map((type) => {
      return { value: type.page_type_id, display: type.page_type_name };
    });
  return [{ value: "", display: "(Select Page Classification)" }].concat(
    pageTypeHtml
  );
};

export function pagetypes(state = [], action) {
  switch (action.type) {
    case pagetypeConstants.PAGETYPE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.list,
        dropdown: handlePageTypes(action.list),
      };
    case pagetypeConstants.PAGETYPE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_TREE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_TREE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tree: action.tree.groups,
      };
    case pagetypeConstants.PAGETYPE_TREE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_GROUP_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_GROUP_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        groups: action.list,
      };
    case pagetypeConstants.PAGETYPE_GROUP_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_FOR_GROUP_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_FOR_GROUP_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        types_for_group: action.list,
      };
    case pagetypeConstants.PAGETYPE_FOR_GROUP_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_CREATE_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_CREATE_GROUP_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        groups: action.list,
      };
    }
    case pagetypeConstants.PAGETYPE_CREATE_GROUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_CREATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_CREATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case pagetypeConstants.PAGETYPE_CREATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_UPDATE_SUCCESS: {
      return {
        ...state,
        list: action.list,
        isLoading: false,
      };
    }
    case pagetypeConstants.PAGETYPE_UPDATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_UNGROUPED_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_UNGROUPED_ID_SUCCESS: {
      return {
        ...state,
        ungrouped_id: action.id,
        isLoading: false,
      };
    }
    case pagetypeConstants.PAGETYPE_UNGROUPED_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_UNCLASSIFIED_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_UNCLASSIFIED_ID_SUCCESS: {
      return {
        ...state,
        unclassified_id: action.id,
        isLoading: false,
      };
    }
    case pagetypeConstants.PAGETYPE_UNCLASSIFIED_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_INSPECTION_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case pagetypeConstants.PAGETYPE_INSPECTION_SUCCESS: {
      return {
        ...state,
        inspection: action.list,
        isLoading: false,
      };
    }
    case pagetypeConstants.PAGETYPE_INSPECTION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case pagetypeConstants.PAGETYPE_SET_CURRENT_PAGETYPE:
      return {
        ...state,
        current_page_type: action.page_type_id,
      };
    default: {
      return state;
    }
  }
}
